import MenuLeft from './menuleft';
import BottomNav from './components/BottomNav/BottomNav';

import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import MessagesContent from './MessagesContent';
import CabinetChildrenList from './components/CabinetChildrenCard/CabinetChildrenList';
import FAQ from './FAQ';
import ApplicationsPage from './Application';

import ModalVisitsCab from './visits';

import ProfilePage from './components/ProfilePage/ProfilePage';

import WizPlain from './wizplain';

import { getEmptyData } from './wizplain/data/emptyform';

import { convertReqToForm } from './wizplain/helpers/convReqToForm';


import {setItem, getItem} from './wizplain/helpers/indexDb';




import './ProfilePage.css';


const STATE_CABINET    = 'statecabinet';
const STATE_WIZARD_TEMP   = 'cabinetwizardtemp';
const STATE_WIZARD_STEP   = 'cabinetwizardstep';
const STATE_WIZARD_ISEDIT = 'cabinetwizardisedit';


const stateInit = localStorage.getItem(STATE_CABINET) || 'applications_act';


const CabinetPage = (props) => {

  const stepPersistentData = localStorage.getItem(STATE_WIZARD_STEP);
  const isEditPersistentData = localStorage.getItem(STATE_WIZARD_ISEDIT);

  const [activeView, setPart]       = useState(stateInit);
  const [prevPart,   setPrev]       = useState('applications');
  const [dataEdit,   setDataEdit]   = useState(null);
  const [isEdit,     setIsEdit]     = useState(isEditPersistentData === 'true' || false);
  const [dictionaryAddress, setDictionary] = useState({});
  const [messagesInfo, setMessagesInfo]    = useState({ all: 0, new: 0 });

  

  useEffect(() => { localStorage.setItem(STATE_CABINET,      activeView); }, [activeView]);
  useEffect(() => { localStorage.setItem(STATE_WIZARD_ISEDIT, isEdit);    }, [isEdit]);

  useEffect(()=>{
    const api = async()=>{
        const data = await getItem(STATE_WIZARD_TEMP);

        if(!!data) return setDataEdit(data);
        setDataEdit(getEmptyData());
    }

     api()

    }, [])


  const clearStorage = async () => {
    localStorage.removeItem(STATE_WIZARD_STEP);
    //localStorage.removeItem(STATE_WIZARD_TEMP);
    await setItem(STATE_WIZARD_TEMP, null);
    localStorage.removeItem(STATE_WIZARD_ISEDIT);
  };

  const onMenuItemClick = (part) => {
    if (activeView === 'wizzard' && part !== 'wizzard') {
      return alert('Спочатку завершить роботу з відкритою формою анкети.');
    }
    setPart(part);
  };

  const onEditApplication = ({ info }) => {
    const _info = convertReqToForm(info);
    setDataEdit(_info);
    setDictionary(info.dictionary && JSON.parse(info.dictionary) || {});
    setIsEdit(true);
    setPrev(activeView);
    setPart('wizzard');
  };

  const onNewApplication = () => {
    if (activeView === 'wizzard') {
      //return alert('Спочатку завершить роботу з вже відкритою формою анкети.');
      return;
    }
    clearStorage();
    setDataEdit(getEmptyData());
    setDictionary({});
    setIsEdit(false);
    setPrev(activeView);
    setPart('wizzard');
  };

  const onFinishApplication = () => {
    setDataEdit(getEmptyData());
    setDictionary({});
    setIsEdit(false);
    clearStorage();
    setPart(prevPart);
  };

  const setPersDataForm = async (data) => {
    //localStorage.setItem(STATE_WIZARD_TEMP, JSON.stringify(data));
    await setItem(STATE_WIZARD_TEMP, data);
  };

  const setPersStep = (step) => {
    localStorage.setItem(STATE_WIZARD_STEP, step);
  };


  const renderChildrenComponent = () => {
    switch (activeView) {
      case 'profile':
        return <ProfilePage />;
      case 'messages':
        return <MessagesContent onInfo={setMessagesInfo} />;
      case 'children':
        return <CabinetChildrenList />;
      case 'wizzard':
        if(!dataEdit) return null;
        return (
          <WizPlain
            onFinish={onFinishApplication}
            isEdit={isEdit}
            data={dataEdit}
            dictionary={dictionaryAddress}
            step={stepPersistentData !== null ? +stepPersistentData : 1}
            setPersData={setPersDataForm}
            setPersStep={setPersStep}
          />
        );
      case 'faq':
        return <FAQ />;
      case 'applications':
      case 'applications_act':
        return <ApplicationsPage onEdit={onEditApplication} type="actual" />;
      case 'applications_closed':
        return <ApplicationsPage onEdit={onEditApplication} type="final" />;
      case 'applications_removed':
        return <ApplicationsPage onEdit={onEditApplication} type="archive" />;
      case 'appointment':
        return <ModalVisitsCab />;
      default:
        return null;
    }
  };


  return (
    <div className="profile-page">
      <main className="main-content">
        <Container fluid>
          <Row>
            {/* Left Sidebar — hidden on mobile via CSS */}
            <Col md={3} className="sidebar d-none d-md-block">
              <MenuLeft
                onMenuItemClick={onMenuItemClick}
                onNewApplication={onNewApplication}
                activeItem={activeView}
                messagesInfo={messagesInfo}
                isPossibleNew={activeView !== 'wizzard'}
              />
            </Col>

            {/* Main Content */}
            <Col xs={12} md={9} className="main-content-area">
              {renderChildrenComponent()}
            </Col>
          </Row>
        </Container>
      </main>

      {/* Bottom Navigation — visible only on mobile via CSS */}
      <BottomNav
        activeItem={activeView}
        onMenuItemClick={onMenuItemClick}
        onNewApplication={onNewApplication}
        messagesInfo={messagesInfo}
      />
    </div>
  );
};

export default CabinetPage;